module.exports = __webpack_public_path__ + "assets/img/1641589449039_.pic_hd.4e5f0460.jpg";